export const arrayToQuery = (name, values) => values
    .map((value) => `${name}=${encodeURIComponent(value)}`)
    .join('&');
export const buildQuery = (params) => Object.entries(params)
    .reduce((result, [key, value]) => {
    if (value === undefined || value === null) {
        return result;
    }
    if (Array.isArray(value)) {
        return `${result}&${arrayToQuery(key, value)}`;
    }
    return `${result}&${key}=${encodeURIComponent(value)}`;
}, '')
    .slice(1);
export const createUrlBuilder = (path) => ((queryParams) => (queryParams === undefined ? path : `${path}?${buildQuery(queryParams)}`));
